import type { SnippetsClientInterface } from './snippetsClient.types';
import type { Snippet } from '~/types/snippet.types';
import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';
import type { QueryParams } from '~/services/api';

export default class CorporateSnippetsClient extends BaseClient implements SnippetsClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getSnippets(params?: QueryParams, config?: ExtendedAxiosRequestConfig) {
        const url = `/api/v3/teams/${this.teamId}/snippets`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getSnippetsCount(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/snippets/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    createSnippet(data: Snippet) {
        const url = `/api/v3/teams/${this.teamId}/snippets`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateSnippet(snippetId: number, data: Snippet) {
        const url = `/api/v3/teams/${this.teamId}/snippets/${snippetId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteSnippet(snippetId: number) {
        const url = `/api/v3/teams/${this.teamId}/snippets/${snippetId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getSnippet(snippetId: number) {
        const url = `/api/v3/teams/${this.teamId}/snippets/${snippetId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    getSnippetsGroupCounts(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/snippets/group-counts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }
}
